import Cookies, { CookieAttributes } from 'js-cookie';
import type { Nullable } from '../types';

export enum CookiesKeys {
  refreshToken = 'refresh_token',
}

export default class CookiesActions {
  static setItem<T extends Record<string, unknown> = Record<string, unknown>>(
    key: CookiesKeys,
    value: string | T,
    options?: CookieAttributes
  ): void {
    if (Object.values(CookiesKeys).includes(key))
      Cookies.set(key, value, options);
  }

  static getItem(key: CookiesKeys): Nullable<string> {
    if (!Object.values(CookiesKeys).includes(key)) return null;
    return Cookies.get(key) || null;
  }

  static deleteItem(key: CookiesKeys): void {
    if (Object.values(CookiesKeys).includes(key)) Cookies.remove(key);
  }
}
